export default __webpack_public_path__ + "static/media/trans_heart.81637dc5.png";